import { createApp } from 'vue'
import App from './App.vue'

// [디버깅용] 모바일 브라우저 백화 현상 원인 파악을 위한 전역 에러 알림
window.onerror = function(message, source, lineno, colno, error) {
  alert('💥 화면 표시 오류 발생!\n' + message + '\n(Line: ' + lineno + ')');
};
window.addEventListener("unhandledrejection", function(event) {
  alert('💥 데이터 로딩 오류 발생!\n' + (event.reason && event.reason.message ? event.reason.message : event.reason));
});

import ValuesplayVue from './lib/valuesplay'
import router from './router'
import { createGtm } from '@gtm-support/vue-gtm'
import { registerSW } from 'virtual:pwa-register';

const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm('New content available! Refresh?')) {
      updateSW();
    }
  },
  onOfflineReady() {
    console.log('App is ready to work offline');
  }
});

// const app = createApp(App)
//   .use(ValuesplayVue)
//   .use(router)

// router.isReady().then(() => {
//   app.mount('#app');
// });

import setI18n from './i18n'
import { keyboardFormDirective } from './directives/keyboardForm'
import { createHead } from '@vueuse/head'

const head = createHead()

setI18n().then((i18n) => {
  const app = createApp(App)
    .use(head)
    .use(ValuesplayVue)
    .use(router)
    .use(
      createGtm({
        id: 'GTM-KPLPBNKW',
        vueRouter: router,
        vueRouterAdditionalEventData: () => ({
          page_path: router.currentRoute.value.fullPath,
          page_location: globalThis.window?.location?.href ?? ''
        })
      })
    )
    .use(i18n)
  app.directive('kb-next', keyboardFormDirective)
  // 새로고침 시 라우터 초기 내비게이션 완료 후 마운트 (route 미준비로 인한 스크립트 에러 방지)
  router.isReady().then(() => {
    app.mount('#app')
    window.i18n = i18n.global
  })
})
